module.exports = __webpack_public_path__ + "img/kgbg_one.png?v=45d339bc";